module.exports = __webpack_public_path__ + "img/icon_appstore.648bcb69.png";